import { apiGet } from "@redriver/cinnamon";

const NAMESPACE = "SYSTEM/WORKSPACE_MENU";

// caps the documents listed inside a folder as well as the sites per page
export const menuPageSize = 15;

export const ActionTypes = {
  GetWorkspaceDirectories: `${NAMESPACE}/GET_WORKSPACE_DIRECTORIES`,
  SetWorkspaceDirectories: `${NAMESPACE}/SET_WORKSPACE_DIRECTORIES`,
  AddWorkspaceDirectory: `${NAMESPACE}/ADD_WORKSPACE_DIRECTORIES`,
  RemoveWorkspaceDirectory: `${NAMESPACE}/REMOVE_WORKSPACE_DIRECTORIES`,
};

export const getWorkspaceDirectories = (
  rootDirectoryId,
  pagination,
  reset = false
) => {
  const { pageSize, pageNumber } = pagination;
  return apiGet(
    ActionTypes.GetWorkspaceDirectories,
    "workspace/tree",
    {
      pageSize,
      pageNumber,
      rootDirectoryId,
      includeFiles: true,
    },
    { actionCustomData: { rootDirectoryId, reset } }
  );
};

export const setWorkspaceDirectories = (data, rootDirectoryId, pageNumber) => {
  return {
    type: ActionTypes.SetWorkspaceDirectories,
    ...data,
    rootDirectoryId,
    pageNumber,
  };
};

// the menu lists documents too, so adding or removing one means refetching the whole node
export const refreshWorkspaceDirectory = (directoryId) => (dispatch) =>
  dispatch(
    getWorkspaceDirectories(directoryId, {
      pageSize: menuPageSize,
      pageNumber: 1,
    })
  ).then((x) => dispatch(setWorkspaceDirectories(x, directoryId, 1)));

export const addWorkspaceDirectory = (
  parentDirectoryId,
  id,
  name,
  reference
) => {
  return {
    type: ActionTypes.AddWorkspaceDirectory,
    parentDirectoryId,
    id,
    name,
    reference,
  };
};

export const removeWorkspaceDirectory = (parentDirectoryId, directoryId) => {
  return {
    type: ActionTypes.RemoveWorkspaceDirectory,
    parentDirectoryId,
    directoryId,
  };
};
